import { setConfiguration } from '@configuratorware/configurator-frontendgui/App/configuration';
import Api from '@configuratorware/configurator-frontendgui/Framework/Api';
import ItemOverview from '../Screens/ItemOverview/ItemOverview';
import ConfiguratorScreen from '../Screens/Configurator/ConfiguratorScreen';
import ConfiguratorService from '../Services/ConfiguratorService';
import InteractionService from '../Services/InteractionService';
import VisualizationService from '../Services/VisualizationService';
import ConfiguratorReducer from '../Reducers/Configurator/Reducer';
import AppReducer from '../Reducers/App/Reducer';

const prod = process.env.NODE_ENV === 'production';

const envDomains = {
  test: '',
  int: 'http://int.lehnert.local',
  local: 'http://int.lehnert.local', // 'http://localhost:11060'
  prod: '',
};

const domain = envDomains[prod ? 'prod' : 'int'];

const query = new URLSearchParams(location.search);

const adminMode = query.get('_adminmode');

const customApplicationConfiguration = {
  network: {
    // timeout: 40000,
    host: domain,
    baseURL: `${domain}/frontendapi/`,
    adminBaseURL: `${domain}/api/`,
    imageURL: `${domain}`,
    resourcesURL: `${domain}`,
  },
  screens: {
    ItemOverview,
    Configurator: ConfiguratorScreen,
  },
  services: {
    ConfiguratorService,
    InteractionService,
    VisualizationService,
  },
  reducers: {
    configurator: ConfiguratorReducer,
    app: AppReducer,
  },
  checkOptionclassificationOnSelect: true,
  showInitialOptionclassification: false,
};

setConfiguration(customApplicationConfiguration);

if (adminMode) {
  // in admin mode all requests should contain the no-cache header to get the most fresh content
  Api.setCacheControlHeader('no-cache');
}

export default customApplicationConfiguration;
